<template>
    <div v-if="projID && proj">

        <div v-if="proj.service_level == 'lite'">
            <ProjectSummaryLite></ProjectSummaryLite>
        </div>
        <div v-else>
            <ProjectSummary></ProjectSummary>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ProjectSummary from './ProjectSummary'
    import ProjectSummaryLite from './ProjectSummaryLite'

    export default {
        name: 'projectSummary',
        data: function () {
            return {
                proj: undefined,
            }
        },
        components: {
            ProjectSummary,
            ProjectSummaryLite,
        },
        // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
        beforeRouteUpdate(to, from, next) {
            // console.log(from.params.projectID + ' ?' + Math.random());
            // console.log(to.params.projectID + ' ?' + Math.random());
            this.getProject(to, from, next);
        },
        mounted() {
            this.getProject();
        },
        computed: {
            ...mapState({
                'project_detail': state => state.project.project_detail,
            }),

            projID() {
                return this.$route.params.projectID;
            },
        },
        methods: {

            getProject(to = undefined, from = undefined, next = undefined) {
                // console.log('projID');
                // console.log(this.projID + ' ?' + Math.random());
                let _projID = (next ? to.params.projectID : this.projID)
                // console.log(_projID);

                this.proj = undefined
                if (_projID) {
                    this.$store.dispatch('project/getProjectDetail', _projID)
                        .then(res => {
                            this.proj = this.project_detail
                            if (next) next();
                        })
                        .catch(err => {})
                }
            },

        },
    }

</script>


<style lang="scss" scoped>

</style>
